import "./prepTimer.scss";
import useNow from "hooks/useNow";
import { formatCountdown, isPrepTimerRunning, prepRemainingSeconds } from "utils/prepTimer";

/**
 * The live half. Only a running timer reads the shared clock, so a delivered
 * order in the list does not re-render every second for nothing.
 */
const RunningPrepTimer = ({ order }) => {
    const now = useNow();
    const seconds = prepRemainingSeconds(order, now);
    if (seconds === null) return null;
    const late = seconds < 0;

    return (
        <span
            className={`prep-timer prep-timer--${late ? "late" : "ok"}`}
            title={
                late
                    ? "انتهى وقت التحضير ولم يستلم السائق الطلب من المطعم بعد"
                    : "الوقت المتبقي من وقت التحضير الذي حدده المطعم"
            }
        >
            {/* A countdown is a left-to-right run inside a right-to-left page:
                without the isolation, the minus sign lands on the wrong side. */}
            <bdi dir="ltr">{formatCountdown(seconds)}</bdi>
        </span>
    );
};

/**
 * «الوقت المتبقي» (admin#40): the restaurant's time counting down, then below
 * zero in red until the driver picks the order up. The rule is in
 * utils/prepTimer.js. `fallback` is what a row shows when there is no timer.
 */
const PrepTimer = ({ order, fallback = "—" }) =>
    isPrepTimerRunning(order) ? (
        <RunningPrepTimer order={order} />
    ) : fallback === null ? null : (
        <span className="text-muted">{fallback}</span>
    );

export default PrepTimer;
